<div [formGroup]="formGroup" class="flex flex-col p-2">
  @if (option.type == 'switch') {
    <div class="caption flex-auto">{{ option.caption }}</div>
  }
  @if (option.parameters.length > 0) {
    <div class="flex flex-col md:flex-row flex-wrap flex-auto pt-2">
      @for (parameter of option.parameters; track parameter) {
        <div class="flex-auto mr-2">
          @if (parameter.type == 'text') {
            <mat-form-field class="w-full" floatLabel="always">
              <mat-label>{{ parameter.caption }}</mat-label>
              <input matInput [formControlName]="parameter.code" placeholder="{{ parameter.caption }}">
            </mat-form-field>
          }
          @if (parameter.type == 'number.weight') {
            <mat-form-field class="w-full" floatLabel="always">
              <mat-label>{{ parameter.caption }}</mat-label>
              <input matInput [formControlName]="parameter.code">
              @if (metric$ | async) {
                <span matSuffix i18n>kgs</span>
              }
              @if (!(metric$ | async)) {
                <span matSuffix i18n>lbs</span>
              }
            </mat-form-field>
          }
          @if (parameter.type == 'choice') {
            <mat-form-field class="w-full" floatLabel="always">
              <mat-label>{{ parameter.caption }}</mat-label>
              <mat-select [formControlName]="parameter.code">
                @for (choice of parameter.choices; track choice) {
                  <mat-option [value]="choice.code">{{ choice.caption }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </div>
      }
    </div>
  }
</div>
